import { observable, makeObservable } from "mobx";
import { IParametroSistema } from "../modelo/ParametroSistema";
import StoreParaSingleton from "./StoreParaSingleton";

class ParametroSistemaStore extends StoreParaSingleton {
    parametros: Array<IParametroSistema> = [];

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        makeObservable(this, {
            parametros: observable
        });
    }
}

export default new ParametroSistemaStore();